import React from 'react';
import './Footer.css';
import { FaInstagram, FaWhatsapp } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-logo">
          <img src={require('../assets/logo.png')} alt="RetroFlex Gym Logo" />
        </div>

        <div className="footer-columns">
          <div>
            <h4>SAIBA MAIS</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="https://wa.me/5511919392331">Planos</Link></li>
              <li>
                <a
                  href="https://retroflexgym.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Loja
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4>INFORMAÇÕES</h4>
            <ul>
              <li><Link to="/politica-de-privacidade">Política de Privacidade</Link></li>
              <li><Link to="/termos-e-condicoes">Termos e Condições</Link></li>
            </ul>
          </div>

          <div>
            <ul className="social-icons">
              <li>
                <a
                  href="www.instagram.com/retro_flex.gym"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram size={24} />
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/5511919392331"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp size={24} />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          Alameda São Caetano, 135; Santa Paula; São Caetano do Sul-SP; CEP: 09070-210 (11) 91939-2331
        </p>
        <p>© 2025 RetroFlex Gym. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
}
